import {defaultBoardLabels} from '@github-ui/board'
import type {BoardColumn} from '@github-ui/board-core'
import {Suspense, useCallback} from 'react'

import {useVisibleFieldIdentifiers} from '../../contexts/views/VisibleFieldsProvider'
import {BoardSurface} from './generic/BoardSurface'
import {BoardCard} from './issues/BoardCard'
import type {BoardPayloadItem} from './issues/board-payload'
import {LabelColumnHeader} from './issues/LabelColumnHeader'
import {useBoardSource} from './use-board-source'

export function SavedViewBoard({owner, repo, query}: {owner: string; repo: string; query: string}) {
  return (
    <Suspense fallback={null}>
      <SavedViewBoardContent owner={owner} repo={repo} query={query} />
    </Suspense>
  )
}

function SavedViewBoardContent({owner, repo, query}: {owner: string; repo: string; query: string}) {
  const visibleFieldIdentifiers = useVisibleFieldIdentifiers()
  const {source, columnLabels} = useBoardSource({owner, repo, query})
  const renderColumnHeader = useCallback(
    (column: BoardColumn) => <LabelColumnHeader column={column} columnLabels={columnLabels} />,
    [columnLabels],
  )

  const renderCard = useCallback(
    (item: BoardPayloadItem) => <BoardCard item={item} visibleFieldIdentifiers={visibleFieldIdentifiers} />,
    [visibleFieldIdentifiers],
  )

  return (
    <BoardSurface
      source={source}
      renderCard={renderCard}
      renderColumnHeader={renderColumnHeader}
      labels={defaultBoardLabels}
    />
  )
}
